import React, { useState } from "react";
import { Modal } from "antd";
import Slider from "react-slick";
import { CaretLeftFilled, CaretRightFilled } from "@ant-design/icons";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../assets/css/ponentes-modern.css";

// imágenes
import ponente1 from "../../assets/images/2026/ponentes/SeminarioIes2026_DanielSalinas.jpg";
import ponente2 from "../../assets/images/2026/ponentes/SeminarioIes2026_DianaJoels.jpg";
import ponente3 from "../../assets/images/2026/ponentes/SeminarioIes2026_EmanuellePerez.jpg";
import ponente4 from "../../assets/images/2026/ponentes/SeminarioIes2026_GabrielaPermeo.jpg";
import ponente9 from "../../assets/images/2026/ponentes/SeminarioIes2026_GiseleSosa.jpg";
import ponente5 from "../../assets/images/2026/ponentes/SeminarioIes2026_IgnacioValero.jpg";
import ponente6 from "../../assets/images/2026/ponentes/SeminarioIes2026_IgorValdebenito.jpg";
import ponente7 from "../../assets/images/2026/ponentes/SeminarioIes2026_JaredSmith.jpg";
import ponente8 from "../../assets/images/2026/ponentes/SeminarioIes2026_LauraArroyo.jpg";
import ponente10 from "../../assets/images/2026/ponentes/SeminarioIes2026_RaquelQuevedo.jpg";
import ponente11 from "../../assets/images/2026/ponentes/SeminarioIes2026_BibianaDavo.jpg";
import ponente12 from "../../assets/images/2026/ponentes/SeminarioIes2026_BrendaCastillo.jpg";

// ... tus demás imágenes

const logos = [
  {
    index: 1,
    img_src: ponente1,
    nombre: "Daniel Salinas",
    informacion: (
      <>
        Daniel Salinas está en su año número 48 en la industria eléctrica. Su experiencia en diseño y gestión de proyectos abarca tanto proyectos comerciales como residenciales, especializándose en abordar instalaciones complicadas con nuevas técnicas de constructabilidad y facilidad de mantenimiento. El diseño de control de iluminación comercial ha sido su pasión, donde trabajar con tecnología integrada es un requisito. Ha recibido dos premios International Awards of Merit de la Illuminating Engineering Society por su trabajo en aplicaciones de proyectos especiales y ha tenido el honor de recibir el IES Distinguished Service Award (DSA) y el IES Marks Award. Ha ocupado puestos de liderazgo dentro de The Illuminating Engineering Society (IES), culminando con el de Presidente del IES para 2013-2014, y continúa sirviendo como miembro de varios comités y grupos de trabajo del IES, incluyendo el de Vicepresidente del comité LP-8 Commissioning Process for Lighting and Lighting Controls, y co-Presidente del IES Membership Committee. Fue Director Ejecutivo Interino de la Illuminating Engineering Society desde junio de 2021 hasta marzo de 2022. También ha servido en el National Council on Qualifications for Lighting Professions (NCQLP) como Presidente del Certification Renewal Committee y en la Junta Directiva del National Lighting Controls Training Program. Es miembro con derecho a voto del comité ASHRAE SSPC100 Energy and Emissions Building Performance Standard for Existing Buildings. En diciembre de 2025 completó su trabajo como co-Presidente del Codes and Standards Working Group para la California Energy Alliance (CEA). Daniel y su esposa Melonie viven en Snohomish, Washington.
      </>
    ),
  },
  {
    index: 2,
    img_src: ponente2,
    nombre: "Diana Joels",
    informacion: [
      <>
        Diana Joels es arquitecta, diseñadora de iluminación titular en Acenda
        Iluminação, consultora de metodología de diseño, educadora independiente
        en Light Drops, co-curadora de contenido de Ledforum, responsable por el
        área lighting design en Istituto Europeo de Design en Río de Janeiro.{" "}
        <br />
        <br />
        Actua en proyectos de iluminación de múltiplas escalas y tipologías,
        siempre con abordaje integral y conceptual, con base en su trayectoria
        de 25 años en Brasil, España y Suecia - donde estudió e integró el
        equipo de maestros del Lighting Laboratory - KTH.
        <br />
        <br />
        Tiene larga experiencia como colaboradora y voluntaria en asociaciones y
        colectivos nacionales e internacionales, como AsBAI, APDI, EILD, Women
        in Lighting Brasil, así como participación en conferencias, cursos y
        workshops en eventos internacionales, como LightFair, Light Symposium y
        Enlighten.
      </>,
    ],
  },
  {
    index: 3,
    img_src: ponente3,
    nombre: "Emanuellle Perez",
    informacion: [
      <>
        Arquitecto mexicano egresado de la Universidad Tecnológica de México en
        2011, ha participado en proyectos de reconocidos arquitectos entre los
        que destacan ARDITTI + RDT ARQUITECTOS, conjunto habitacional Parques
        Polanco y Corporativo Reforma Diana.
        <br />
        <br />
        Funda emARTquitectura con la intención de reunir a profesionales de
        distintos campos del diseño como gráfico, industrial, iluminación,
        interior, paisajismo, entre otros; para ofrecer soluciones
        arquitectónicas integrales.
        <br />
        <br />
        Junto con su equipo, ganó el segundo lugar internacional de "Fachadas
        Bioclimáticas" organizado por SOMFY. Además ganó mención honorífica en
        el 14vo. Concurso Arquine "Albergue para desplazados", ha sido
        considerado como TALENTO JOVEN por la revista "a+a" y fue seleccionado
        por la VI Bienal Iberoamericana Iluminet.
        <br />
        <br />
        En 2016, su pasión por la luz lo hace especializarse en Diseño de
        Iluminación Arquitectónica por la Universidad Nacional Autónoma de
        México (Ciudad Universitaria, C.U.) con el fin de incorporar esta visión
        al trabajo que realiza. Esto lo ha impulsado a trabajar de la mano con
        arquitectos, artistas, iluminadores, diseñadores, fotógrafos e
        ingenieros como: Arq. Jorge Arditti (ARDITTI + RDT ARQUITECTOS), Arq.
        Ricardo Noriegga (NORIEGGA ILUMINADORES), Antonio O'Connell (ARTISTA),
        Arq. Gustavo Avilés (LIGHTEAM), Arq. Hugo López Castro (ARQUINTEGRA),
        entre otros.
      </>,
    ],
  },
  { index: 4, img_src: ponente4, nombre: "Gabriela Bermeo", informacion: [<>Gabriela Bermeo es arquitecta por la Universidad La Salle (CDMX), Maestra en Diseño
Estratégico e Innovación por la Universidad Iberoamericana (Mención Honorífica) y
especialista en Iluminación de Interiores por CENTRO.<br />
        <br />
Cuenta con más de 15 años de experiencia en gestión cultural y conservación patrimonial.
Fue Subdirectora de la Casa Luis Barragán (2010–2023), donde coordinó el Plan de Manejo
del sitio ante la UNESCO y lideró estrategias de conservación, restauración y programación
académica, profundizando en la relación entre luz, atmósfera y experiencia espacial en la
arquitectura moderna.<br />
        <br />
Actualmente es Directora de Gestión Cultural en la Casa Estudio Max Cetto y docente en la
Universidad La Salle y en CENTRO (Diseño, Cine y Televisión), donde imparte asignaturas
vinculadas a Cultura de la Luz, Diseño de Iluminación y Prospectiva. También formó parte
del cuerpo docente de la Maestría en Diseño Estratégico e Innovación en la Universidad
Iberoamericana.<br />
        <br />
Ha participado en congresos, publicaciones y conferencias nacionales e internacionales
sobre arquitectura, patrimonio, color y luz.<br />
        <br />
Actualmente articula su investigación a través de FRKLab, un laboratorio de pensamiento
dedicado a explorar la iluminación como lenguaje cultural y simbólico, integrando light art,
arte digital, diseño especulativo y prospectiva para generar reflexión crítica sobre el
presente y el futuro de la luz como fenómeno cultural y social.</>] },
  { index: 5, img_src: ponente5, nombre: "Ignacio Valero", informacion: [<>Arquitecto de formación, con un doctorado cum laude en iluminación natural, es
sobre todo un apasionado por la luz, que tiene la inmensa fortuna de trabajar en lo
que más le gusta, la iluminación.<br />
        <br />
Como consultor, trabaja desde hace más de veinticinco años como diseñador de
iluminación para la arquitectura, desde ARKILUM, la consultoría independiente que
fundó y dirige actualmente. Ha tenido la fortuna de trabajar regularmente con
muchos de los equipos de arquitectura más destacados en proyectos de una enorme
variedad de tipologías y elevada exigencia arquitectónica, así como con propiedades
y promotores de primer nivel, dentro y fuera de nuestras fronteras.<br />
        <br />
Como docente, desarrolló una intensa actividad, especializada en la iluminación,
primero en la Escuela Superior de Diseño de Madrid, y más tarde en la Escuela
Técnica Superior de Arquitectura también de Madrid. En este último centro impulsó
durante más de diez años Masterdía, que fue el primer programa de postgrado en
diseño de iluminación en habla española. Imparte regularmente charlas y talleres de
iluminación, tanto en España como internacionalmente.<br />
        <br />
Ha sido uno de los socios fundadores de APDI, la Asociación Profesional de
Diseñadores de Iluminación de España, y colabora también con otras asociaciones y
colectivos del sector como DIMAD.</>] },
  { index: 6, img_src: ponente6, nombre: "Igor Valdebenito", informacion: [<>Igor Valdebenito Ojeda es Ingeniero Acústico de la Universidad Austral de Chile, Diplomado en Gestión Ambiental de la Universidad de Chile y Magíster en Administración Pública (MPA), mención Medio Ambiente, de Columbia University.<br />
        <br />
Cuenta con más de 20 años de experiencia en el sector público, donde ha liderado y coordinado estrategias regulatorias en el Ministerio del Medio Ambiente de Chile, especialmente en materias de ruido ambiental y contaminación lumínica. Ha desempeñado un rol clave en el desarrollo, actualización e implementación de la normativa de contaminación lumínica en el país, siendo uno de los principales referentes técnicos en esta materia a nivel nacional.<br />
        <br />
Su trabajo ha estado enfocado en la protección de la calidad de los cielos nocturnos, la reducción de impactos ambientales de la iluminación artificial y la articulación entre ciencia, regulación y política pública. Además, participa como docente invitado en programas de magíster y diplomados en temas de gestión ambiental.
</>] },
  { index: 7, img_src: ponente7, nombre: "Jared Smith", informacion: [<>La mayoría de los consejos sobre mantenerse motivado apuntan hacia adentro: encuentra tu propósito, protege tu energía, mantente curioso. Todo gira en torno a generar algo desde dentro de uno mismo, como si el compromiso fuera un recurso que se puede acumular con suficiente disciplina.<br /> <br />
Jared considera que ese modelo es incompleto. Las personas que permanecen genuinamente comprometidas a lo largo de una larga carrera no han encontrado mejor disciplina que los demás. Han construido mejores insumos, cultivando deliberadamente contextos donde el intercambio honesto es estructuralmente posible, y donde alguien les dirá algo verdadero.<br /> <br />
Recurriendo a sus quince años en consultoría de ingeniería, gestión de personas, liderazgo voluntario en la IES y una amistad profesional improbable con un competidor al que apenas conocía, Jared traza los entornos de información que han moldeado su forma de pensar, y argumenta que construirlos, no solo beneficia tu propia carrera, te convierten en un mejor recurso para quienes te rodean.<br /> <br />
Esta sesión es para profesionales en cualquier etapa de su carrera que quieran mantenerse enfocados, no esforzándose más, sino construyendo mejores condiciones.
</>] },
  { index: 8, img_src: ponente8, nombre: "Laura Arroyo", informacion: [<>Laura Arroyo Rocha es diseñadora de iluminación y fundadora de FLOU Lighting Design, con más de 15 años de experiencia en proyectos de hostelería, retail y residencial en México, Estados Unidos y Europa. Su práctica desarrolla proyectos internacionales enfocados en transformar la atmósfera, la percepción y la experiencia de los espacios a través de la luz.
 <br /> <br />
Arquitecta por el Tecnológico de Monterrey y Maestra en Theatre Design por la University of the Arts London, su enfoque combina sensibilidad espacial, narrativa y bienestar para crear experiencias significativas. En 2022 fue una de las 20 ganadoras de los Silhouette Awards y varios de sus proyectos han recibido premios internacionales.
 <br /> <br />
Es Design Member de la International Association of Lighting Designers (IALD) y miembro de la Asociación Profesional de Diseñadores de Iluminación (APDI) en España. Participa activamente como docente, conferencista y colaboradora en iniciativas internacionales que impulsan el valor estratégico del diseño de iluminación.</>] },
  { index: 9, img_src: ponente9, nombre: "Gisele Sosa", informacion: [<>Gisele Sosa Santibañez es Ingeniera en Electrónica y Telecomunicaciones por la Universidad La Salle, y cuenta con una Maestría en Domótica y Hogar Digital por la Universidad Politécnica de Madrid (2008).<br /><br />
De 2023 a 2025 se desempeñó como Vicepresidenta del Sector TIC’s en AMERIC, consolidando iniciativas de profesionalización y fortalecimiento tecnológico dentro del sector eléctrico. Es Socia Fundadora y Directora Técnico-Comercial de Aditel Sistemas, empresa con 28 años de trayectoria especializada en proyectos de Inmótica, Domótica y Urbótica.<br /><br />
A lo largo de su carrera ha liderado la formación de más de 80 profesionales y empresas, y ha diseñado y ejecutado más de 90 proyectos en México y Latinoamérica. Su trabajo se ha enfocado en la integración tecnológica, eficiencia energética y gestión inteligente de infraestructura, mediante la implementación de sistemas de automatización y control bajo estándares internacionales en edificios comerciales, desarrollos residenciales de gran escala, industria 4.0 y proyectos de ciudades inteligentes.<br /><br />
En 2025 diseñó y ejecutó el Diplomado en Diseño de Sistemas de Automatización y Control de Edificios para AMERIC, contribuyendo a la profesionalización técnica del sector.<br /><br />
En el marco del VI Congreso Nacional de Mujeres en la Industria Eléctrica, celebrado durante la Expo Eléctrica Internacional 2025, compartió escenario con destacadas líderes del sector y recibió un reconocimiento otorgado por el Comité de Mujeres de AMERIC A.C. y CONACOMEE, en honor a su trayectoria, liderazgo e impacto en la industria.<br /><br />
</>] },
  { index: 10, img_src: ponente10, nombre: "Raquel Quevedo", informacion: [<>Diseñadora de Interiores por ESDI (Escuela Superior de Diseño de Interiores Arte 4) y especializada en Iluminación Arquitectónica por la ETSAM (Escuela Técnica Superior de Arquitectura de Madrid). MDIA (Máster Diseño de Iluminación Arquitectónica) en 2007. Miembro de APDI desde 2019.
 <br /> <br />
Otras formaciones complementarias: 
 <br /> <br />
Postgrado en RSC y liderazgo sostenible, por OBS Business School y la UB (Universitat de Barcelona).  <br />
EMBA (Executive Master Bussiness Administration), MIE (Master en Innovación y Emprendimiento), por OBS Business School y la UB (Universitat de Barcelona).<br />
Postgrado en Diseño de escenografía y Arquitectura del Espectáculo por el IED (Instituto Europeo de Diseño).<br />
<br /><br />
Con más de 15 años de experiencia en el campo de la iluminación, desarrollando su trabajo en diferentes áreas enfocada en la divulgación y el desarrollo estratégico corporativo, de producto y la gestión de proyectos.
<br /><br />
Además, ha colaborado con creación de contenidos para el medio especializado digital Lightroom.Lighting, Lightecture y la revista Diseño Interior, así como colaboraciones como ponente en diferentes escuelas técnicas y asociaciones como “El Lenguaje de la Luz” en ETSEM-UPM, HUB EDUCA-INSPIRA-CONECTA de Comunidad de la Academia de Arquitectura y Diseño EXKEMA (Colombia), Congreso Green Pacto (Secartys), WELLFERENCE (ITG) entre otras.
<br /><br />
Actualmente es docente colaboradora Curso de especialización en Diseño de Iluminación Arquitectónica de IED Kunsthal Bilbao.
</>] },{
    index: 11,
    img_src: ponente11,
    nombre: "Bibiana Davó Sayrols",
    informacion: (
      <>
        Bibiana Davó Sayrols es paisajista y fundadora de Devas Paisaje, estudio mexicano
especializado en el diseño y construcción de espacios exteriores que integran la naturaleza con
la arquitectura.<br /><br />
Es licenciada en Comunicación y posteriormente cursó una maestría en Arquitectura de Paisaje
en la Universidad Anáhuac. Encontró su vocación en el paisajismo en 2004, a partir del diseño
de su primer jardín, lo que la llevó a especializarse y desarrollar su propia firma en 2007.<br /><br />
A través de Devas Paisaje, ha trabajado en proyectos residenciales, corporativos y comerciales,
creando espacios que buscan mejorar la calidad de vida mediante el equilibrio entre
vegetación, entorno y diseño arquitectónico. Su enfoque se centra en generar experiencias
habitables en el exterior, donde las personas puedan convivir, trabajar y descansar en armonía
con la naturaleza.<br /><br />
Su trabajo ha sido reconocido a nivel internacional, destacando el primer lugar en la Bienal
Latinoamericana de Arquitectura de Paisaje en 2016, así como su participación constante en
foros y bienales del sector.
      </>
    ),
  },{
    index: 12,
    img_src: ponente12,
    nombre: "Brenda Castillo",
    informacion: (
      <>
        Arquitecta egresada de la UNAM-FES Acatlán, con enfoque en diseño museográfico por la Facultad de Artes y Diseño de la UNAM. Es profesora de Composición Lumínica en el curso propedéutico de la Especialidad en Diseño de Iluminación Arquitectónica de la UNAM.
<br /><br />
Actualmente se desempeña como directora general dentro de la Asociación Internacional de Diseñadores de Iluminación (IALD), donde también coordina las actividades regionales en México.
<br /><br />
Codirige el estudio de diseño de iluminación arquitectónica Circadia y es cofundadora de Luz Sin Fronteras México, una organización sin fines de lucro dedicada al desarrollo de proyectos de iluminación con impacto social.
<br /><br />
Su trabajo ha sido reconocido internacionalmente con premios como los Darc Awards, LIT Awards, IES Illumination Awards, Construlita Lighting Awards y en la Bienal de Iluminación de Iberoamérica, con proyectos realizados en México y Guatemala. En 2021 fue seleccionada como una de las ganadoras del 40 under 40 lighting, reconocimiento global que destaca a jóvenes profesionales sobresalientes por su creatividad en la aplicación de la iluminación en la arquitectura.

      </>
    ),
  },
];

const CarouselPonentes2 = ({ idioma }) => {
  const [persona, setPersona] = useState(null);

  const Next = ({ onClick }) => (
    <div className="arrow next" onClick={onClick}>
      <CaretRightFilled />
    </div>
  );

  const Prev = ({ onClick }) => (
    <div className="arrow prev" onClick={onClick}>
      <CaretLeftFilled />
    </div>
  );

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    centerMode: true,
    centerPadding: "0px",
    nextArrow: <Next />,
    prevArrow: <Prev />,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 500, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="ponente_section">
      <h2 className="titulo_ponentes inter">CONFERENCISTAS</h2>

      <Slider {...settings}>
        {logos.map((item) => (
          <div key={item.index} className="slide_item">
            <div
              className="card_poster"
              onClick={() => {
                setPersona(item);
                console.log(item);
              }}
            >
              <img src={item.img_src} alt={item.nombre} />

              <div className="overlay">
                <span className="nombre">{item.nombre}</span>
              </div>
            </div>
          </div>
        ))}
      </Slider>

      <Modal
        open={!!persona}
        onCancel={() => setPersona(null)}
        footer={null}
        centered
        width={900}
      >
        {persona && (
          <div className="modal_content">
            <img src={persona.img_src} alt="" />
            <h3>{persona.nombre}</h3>
            <p>{persona.informacion}</p>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default CarouselPonentes2;
